import { ObjectId } from 'bson';
import { IsBoolean, IsEnum, IsNumber, IsOptional } from 'class-validator';
import { QueueNames } from '../../@api/queue-names.enum';
import { BaseDto } from '../../@base/base.dto';

export type JobConfigId = ObjectId & { readonly __brand: unique symbol };

export class JobConfigDto extends BaseDto<JobConfigId> {
  @IsEnum(QueueNames)
  queueName!: QueueNames;

  @IsBoolean()
  paused!: boolean;

  @IsNumber()
  @IsOptional()
  concurrency?: number;

  @IsNumber()
  @IsOptional()
  maxAttempts?: number;

  @IsNumber()
  @IsOptional()
  backoffDelay?: number;
}

export class UpdateJobConfigDto {
  @IsBoolean()
  @IsOptional()
  paused?: boolean;

  @IsNumber()
  @IsOptional()
  concurrency?: number;

  @IsNumber()
  @IsOptional()
  maxAttempts?: number;

  @IsNumber()
  @IsOptional()
  backoffDelay?: number;
}
